/* eslint-disable max-len */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { RecipesFormComponent } from './recipes-form/recipes-form.component';
import { RecipesFormNewComponent } from './recipes-form/recipes-form-new/recipes-form-new.component';
import { RecipesFormEditComponent } from './recipes-form/recipes-form-edit/recipes-form-edit.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RecipesFormBodyComponent } from './recipes-form/recipes-form-edit/recipes-form-body/recipes-form-body.component';
import { VariantTabComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab.component';
import { VariantTabHeaderComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-header/variant-tab-header.component';
import { VariantTabBodyComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-tab-body.component';
import { VariantStepIngredientsComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-ingredients/variant-step-ingredients.component';
import { VariantStepInstructionsComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-instructions/variant-step-instructions.component';
import { VariantStepInformationsComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-informations/variant-step-informations.component';
import { VariantStepCommentsComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-comments/variant-step-comments.component';
import { FormYieldComponent } from '@shared/components/form-yield/form-yield.component';
import { NewVariantTabComponent } from './recipes-form/recipes-form-edit/recipes-form-body/new-variant-tab/new-variant-tab.component';
import { MatRadioModule } from '@angular/material/radio';
import { IngredientsBlockComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-ingredients/ingredients-block/ingredients-block.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MarketingFoodFormFieldComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-ingredients/ingredients-block/marketing-food-form-field/marketing-food-form-field.component';
import { HelpFastInputComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/help-fast-input/help-fast-input.component';
import { HelpFastInputDialogComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/help-fast-input/help-fast-input-dialog/help-fast-input-dialog.component';
import { RecipesCopyByImportComponent } from './recipes-copy-by-import/recipes-copy-by-import.component';
import { TimeInputsComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-instructions/time-inputs/time-inputs.component';
import { StepsBlockComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-instructions/steps-block/steps-block.component';
import { ProgrammeInputsComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-instructions/programme-inputs/programme-inputs.component';
import { BasePreparationBlockComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-ingredients/base-preparation-block/base-preparation-block.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RecipesSearchComponent } from './recipes-search/recipes-search.component';
import { RecipesSearchQueryComponent } from './recipes-search/recipes-search-query/recipes-search-query.component';
import { RecipesSearchFacetsComponent } from './recipes-search/recipes-search-facets/recipes-search-facets.component';
import { MediaSelectorInputsComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-instructions/media-selector-inputs/media-selector-inputs.component';
import { SemantizationBlockComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-informations/semantization-block/semantization-block.component';
import { SharedLibsModule } from '@shared/shared-libs.module';
import { MatChipsModule } from '@angular/material/chips';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NewFormFieldSelectAutocompleteComponent } from '@shared/components/new-form-field-select-autocomplete/new-form-field-select-autocomplete.component';
import { ApplianceGroupsControlComponent } from './recipes-form/appliance-groups-control/appliance-groups-control.component';
import { DataTableComponent } from '@shared/components/data-table-manager/data-table/data-table.component';
import { DataTableManagerComponent } from '@shared/components/data-table-manager/data-table-manager.component';
import { NutritionalInformationComponent } from './recipes-form/recipes-form-edit/recipes-form-body/variant-tab/variant-tab-body/variant-step-informations/nutritional-information/nutritional-information.component';
import { UtensilGroupControlComponent } from './recipes-form/utensil-group-control/utensil-group-control.component';
import { RecipeSearchBarComponent } from './recipes-search/recipes-search-query/recipe-search-bar/recipe-search-bar.component';
import { RecipeHeadbandComponent } from './recipes-search/recipes-search-query/recipe-headband/recipe-headband.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { RecipesTranslationSectionComponent } from '@recipes/recipes-translation/recipes-translation-section/recipes-translation-section.component';
import { RecipesTranslationFieldsContainerComponent } from '@recipes/recipes-translation/recipes-translation-fields-container/recipes-translation-fields-container.component';
import { RecipesTranslationInputFieldsComponent } from '@recipes/recipes-translation/recipes-translation-input-fields/recipes-translation-input-fields.component';
import { RecipesFormHeaderComponent } from '@shared/components/recipes-form-header/recipes-form-header.component';
import { EditNamePopinComponent } from '@shared/components/recipes-form-header/edit-name-popin/edit-name-popin.component';
import { ClassificationsComponent } from '@shared/components/recipes-form-header/classifications/classifications.component';
import { BinariesManagementPopinComponent } from '@shared/components/recipes-form-header/binaries-management-popin/binaries-management-popin.component';
import { GenerateBinaryFormComponent } from '@shared/components/recipes-form-header/binaries-management-popin/generate-binary-form/generate-binary-form.component';
import { BinariesListComponent } from '@shared/components/recipes-form-header/binaries-management-popin/binaries-list/binaries-list.component';
import { CatalogComponent } from '@shared/components/recipes-form-header/classifications/catalog/catalog.component';
import { MediasListComponent } from '@shared/components/recipes-form-header/classifications/medias-list/medias-list.component';
import { CopyRecipePopinComponent } from '@shared/components/recipes-form-header/copy-recipe-popin/copy-recipe-popin.component';
import { ReworkRecipePopinComponent } from '@shared/components/recipes-form-header/rework-recipe-popin/rework-recipe-popin.component';
import { SeoComponent } from '@shared/components/recipes-form-header/seo/seo.component';
import { EditoComponent } from '@shared/components/recipes-form-header/edito/edito.component';
import { recipeStatusGuardFn } from '@guards/recipe-status.guard';
import { RecipesTranslationComponent } from './recipes-translation/recipes-translation/recipes-translation.component';
import { SavedSearchFiltersComponent } from '@shared/components/saved-search-filters/saved-search-filters.component';
import { PacksSearchDialogComponent } from '@shared/components/packs-search-dialog/packs-search-dialog.component';
import { FilterDomainMarketLangComponent } from '@shared/components/filter-domain-market-lang/filter-domain-market-lang.component';
import { SearchBarTableComponent } from '@shared/components/data-table-manager/search-bar-table/search-bar-table.component';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

@NgModule({
  declarations: [
    RecipesFormComponent,
    RecipesFormNewComponent,
    RecipesFormEditComponent,
    EditNamePopinComponent,
    BinariesManagementPopinComponent,
    GenerateBinaryFormComponent,
    BinariesListComponent,
    RecipesFormBodyComponent,
    VariantTabComponent,
    VariantTabHeaderComponent,
    VariantTabBodyComponent,
    VariantStepIngredientsComponent,
    VariantStepInstructionsComponent,
    VariantStepInformationsComponent,
    VariantStepCommentsComponent,
    FormYieldComponent,
    NewVariantTabComponent,
    IngredientsBlockComponent,
    MarketingFoodFormFieldComponent,
    HelpFastInputComponent,
    HelpFastInputDialogComponent,
    RecipesCopyByImportComponent,
    TimeInputsComponent,
    StepsBlockComponent,
    ProgrammeInputsComponent,
    BasePreparationBlockComponent,
    RecipesSearchComponent,
    RecipesSearchQueryComponent,
    RecipesSearchFacetsComponent,
    MediaSelectorInputsComponent,
    SemantizationBlockComponent,
    CopyRecipePopinComponent,
    CopyRecipePopinComponent,
    ReworkRecipePopinComponent,
    ApplianceGroupsControlComponent,
    UtensilGroupControlComponent,
    PacksSearchDialogComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SharedLibsModule,
    RouterModule.forChild([
      // { path: 'search', component: ClientsSearchComponent },
      { path: 'edit/translation/:topRecipeId', component: RecipesTranslationComponent },
      {
        path: 'edit/:recipeType/:version/:type/:recipeId',
        component: RecipesFormComponent,
        canActivate: [recipeStatusGuardFn],
      },
      { path: 'edit/:recipeType/:recipeId', component: RecipesFormComponent, canActivate: [recipeStatusGuardFn] },
      { path: 'new', component: RecipesFormComponent },
      { path: 'copy-by-import', component: RecipesCopyByImportComponent },
      { path: 'search', component: RecipesSearchComponent },
    ]),
    MatProgressSpinnerModule,
    MatRadioModule,
    DragDropModule,
    MatSlideToggleModule,
    MatChipsModule,
    NewFormFieldSelectAutocompleteComponent,
    DataTableComponent,
    DataTableManagerComponent,
    NutritionalInformationComponent,
    RecipeSearchBarComponent,
    RecipeHeadbandComponent,
    SeoComponent,
    EditorModule,
    EditoComponent,
    RecipesTranslationSectionComponent,
    RecipesTranslationFieldsContainerComponent,
    RecipesTranslationInputFieldsComponent,
    RecipesFormHeaderComponent,
    ClassificationsComponent,
    MediasListComponent,
    CatalogComponent,
    SavedSearchFiltersComponent,
    FilterDomainMarketLangComponent,
    SearchBarTableComponent,
    NgxMaskDirective,
  ],
  providers: [
    {
      provide: MatDialogRef,
      useValue: {},
    },
    { provide: MAT_DIALOG_DATA, useValue: { myData: {} } },
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' },
    provideNgxMask(),
  ],
})
export class RecipesModule {}
